
import { DataTexture, EquirectangularReflectionMapping, LoadingManager, Scene, Texture, TextureLoader, sRGBEncoding } from "three";
import { GLTF, GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { Params } from "../../utils/types";
import { LoadedGLTFs, LoadedTextures } from "./types";

let pack2BrushSrc = new URL("../../assets/models/2_pack_brush.glb", import.meta.url).href;
let pack5BrushSrc = new URL("../../assets/models/5_pack_brush.glb", import.meta.url).href;
let pack12BrushSrc = new URL("../../assets/models/12_pack_brush.glb", import.meta.url).href;
let pack2BulletSrc = new URL("../../assets/models/2_pack_bullet.glb", import.meta.url).href;
let pack5BulletSrc = new URL("../../assets/models/5_pack_bullet.glb", import.meta.url).href;
let pack12BulletSrc = new URL("../../assets/models/12_pack_bullet.glb", import.meta.url).href;
let penBulletSrc = new URL("../../assets/models/pen_bullet.glb", import.meta.url).href;
let penBrushSrc = new URL("../../assets/models/pen_brush.glb", import.meta.url).href;
let paperSrc = new URL("../../assets/models/paper.glb", import.meta.url).href;
let penAnimBrushSrc = new URL("../../assets/models/pen_anim_brush.glb", import.meta.url).href;
let penAnimBulletSrc = new URL("../../assets/models/pen_anim_bullet.glb", import.meta.url).href;

let watermarkSrc = new URL("../../assets/images/SharpieBlackWhiteOutlineLogo.png", import.meta.url).href;
//let menuBackgroundSrc = new URL("../../assets/images/PaperTextureBrushnColourSelection.png", import.meta.url).href;
const manager = new LoadingManager();
let envMapSrc = new URL("../../assets/images/hdrImage.hdr", import.meta.url).href;
//const dracoLoader = new DRACOLoader(manager).setDecoderPath("'/examples/jsm/libs/draco/' /")const dracoDecoder = new URL('../../../node_modules/three/examples/jsm/libs/draco/draco_decoder.js', import.meta.url).toString();
//const dracoLoader = new DRACOLoader(manager).setDecoderPath(dracoDecoder);
//const dracoLoader = new DRACOLoader(manager).setDecoderPath(../../../node_modules/three/examples/jsm/libs/draco/draco_decoder.js');
// dracoLoader.preload();
//const gltfLoader = new GLTFLoader(manager).setDRACOLoader(dracoLoader)

const gltfLoader = new GLTFLoader(manager);
const rgbeLoader = new RGBELoader(manager);

let gltfs: LoadedGLTFs = {};
let textures: LoadedTextures = {};

let gltfNames = ['pen_brush', 'pen_bullet', 'pack', 'paper', 'penAnim']
let textureNames = ['watermark'];


export const loadGltfs = async (urlParams: Params) =>
    Promise.all<GLTF>(
        [loadGltf(gltfNames[0], urlParams),
        loadGltf(gltfNames[1], urlParams),
        loadGltf(gltfNames[2], urlParams),
        loadGltf(gltfNames[3], urlParams),
        loadGltf(gltfNames[4], urlParams),
        ]).then((gltfsArr: Array<GLTF>) => {
            gltfsArr.forEach((gltf, index) => { gltfs[gltfNames[index]] = gltf; });
            return gltfs
        });

export const loadGltf = async (name: string, urlParams: Params) =>
    await new Promise<GLTF>((resolve, _) => {
        let modelSrc = name == 'pen_brush' ? penBrushSrc : name == 'pen_bullet' ? penBulletSrc :
            name == 'paper' ? paperSrc :
                name == 'penAnim' ? urlParams.penType == 'brush' ? penAnimBrushSrc : penAnimBulletSrc :
                    urlParams.penType == 'brush' ?
                        urlParams.penNum == 12 ? pack12BrushSrc : urlParams.penNum == 5 ? pack5BrushSrc : pack2BrushSrc :
                        urlParams.penNum == 12 ? pack12BulletSrc : urlParams.penNum == 5 ? pack5BulletSrc : pack2BulletSrc;

        gltfLoader.load(
            modelSrc,
            function (gltf) {
                resolve(gltf);
            },
            undefined,
            function (error) {
                console.warn("An error happened");
            });
    });

export const loadTextures = async () =>
    await Promise.all<Texture>(
        [loadTexture(textureNames[0]),
            //loadTexture(textureNames[1]),
        ]).then((texturesArr: Array<Texture>) => {
            texturesArr.forEach((texture, index) => { textures[textureNames[index]] = texture; });
            return textures
        });


export const loadTexture = async (name: string) =>
    await new Promise<Texture>((resolve, _) => {
        let textureSrc = watermarkSrc;
        let texture = new TextureLoader().load(textureSrc);
        texture.encoding = sRGBEncoding;
        resolve(texture);
    });



export const loadRgbe = async (scene: Scene) =>
    await new Promise<DataTexture>((resolve, _) => {
        rgbeLoader.load(envMapSrc, function (texture: DataTexture) {
            texture.mapping = EquirectangularReflectionMapping;
            scene.environment = texture;
            resolve(texture)
        });
    });
